import { ICurrencyPreview } from "./useCurrency";

export interface ICurrency {
  thousandsSeparator: string;
  decimalPlaces: number;
  decimalMark: string;
  symbol: string;
  symbolFirst: boolean;
  isoCode: string;
}

export interface ICurrencyInput {
  thousandsSeparator?: string;
  exponent?: number;
  decimalMark?: string;
  symbol?: string;
  isoCode?: string;
  symbolFirst?: boolean;
}

export const defaultCurrency = (
  currency?: ICurrencyPreview | ICurrencyInput | null,
): ICurrency => {
  return {
    thousandsSeparator: currency?.thousandsSeparator ?? ",",
    decimalPlaces: currency?.exponent ?? 2,
    decimalMark: currency?.decimalMark ?? ".",
    symbol: currency?.symbol ?? "$",
    isoCode: currency?.isoCode ?? "USD",
    symbolFirst: currency?.symbolFirst ?? true,
  };
};
